import React from 'react';
import DtvBox from '@directv-digital/dds.ui.dtv-box';
import DtvButton from '@directv-digital/dds.ui.dtv-button';
import DtvText, { IDtvTextProps } from '@directv-digital/dds.ui.dtv-text';

interface PdfLinksErrorDisplayProps {
  isChannelsQPValid: boolean;
  isErrorScenario: string;
  isLangQPValid: boolean;
  isModalSrcValid: boolean;
  isPkgQPValid: boolean;
  isCmprPkgQPValid: boolean;
  packages?: any[];
  channelsQP?: string;
  internetHeadline?: string;
  satelliteHeadline?: string;
  headline?: string;
  errorMessageForModal?: IDtvTextProps;
  internetChnlsPDFLink?: any;
  internetSpanishChnlsPDFLink?: any;
  satelliteChnlsPDFLink?: any;
  satelliteSpanishChnlsPDFLink: any;
}

export const PdfLinksErrorDisplay: React.FC<PdfLinksErrorDisplayProps> = ({
  isChannelsQPValid,
  channelsQP,
  internetHeadline,
  satelliteHeadline,
  headline,
  errorMessageForModal,
  internetChnlsPDFLink,
  internetSpanishChnlsPDFLink,
  satelliteChnlsPDFLink,
  satelliteSpanishChnlsPDFLink,
  isErrorScenario,
  isLangQPValid,
  isModalSrcValid,
  isPkgQPValid,
  isCmprPkgQPValid,
  packages
}) => {
  // eslint-disable-next-line camelcase
  const channelsQP_upc = channelsQP?.toUpperCase() || "";
  return (
    <DtvBox sx={{ backgroundColor: "#F4F4F4" }}>
      <DtvText
        variant="h2"
        content={
          // eslint-disable-next-line camelcase
          isChannelsQPValid && channelsQP_upc === "INTERNET" ?
            internetHeadline || "DIRECTV Internet Channel Lineup" :
            // eslint-disable-next-line camelcase
            isChannelsQPValid && channelsQP_upc === "SATELLITE" ?
            satelliteHeadline || "DIRECTV Satellite Channel Lineup" :
            headline || "DIRECTV Channel Lineup"
        }
      />
      <DtvText
        variant="body2"
        sx={{
 pt: "8px",
color: "#102641"
}}
        {...errorMessageForModal}
      />
      <DtvBox id="pdf-links">
        {isErrorScenario === 'english' ? (
          <>
            {(
              // eslint-disable-next-line camelcase
              (isLangQPValid && (isChannelsQPValid && channelsQP_upc === "INTERNET")) ||
              // eslint-disable-next-line camelcase
              ((channelsQP_upc && isChannelsQPValid) ?
                    // eslint-disable-next-line camelcase
                    (channelsQP_upc === "INTERNET") :
                    (isLangQPValid && (!isModalSrcValid || !isChannelsQPValid || !isPkgQPValid || !isCmprPkgQPValid))) ||
              // eslint-disable-next-line camelcase
              ((channelsQP_upc && isChannelsQPValid) ?
                    // eslint-disable-next-line camelcase
                    (channelsQP_upc === "INTERNET") :
                    (!isModalSrcValid || !isChannelsQPValid || !isLangQPValid || !isPkgQPValid || !isCmprPkgQPValid)) ||
              packages?.length === 0
            ) &&
              <DtvButton
                analytics={internetChnlsPDFLink?.analytics}
                mode={internetChnlsPDFLink?.mode || "light"}
                tabIndex={0}
                variant={internetChnlsPDFLink?.variant || "uxtext"}
                {...internetChnlsPDFLink}
                sx={{
                  display: "block !important",
                  textAlign: "left",
                  marginTop: {
 xs: "32px",
sm: "26px"
},
                  color: "#2E70BD",
                  fontSize: "16px",
                  textDecoration: "none",
                  width: "fit-content",
                  ":focus": {
                    border: "2px solid #3885E1",
                    borderRadius: '100px'
                  }
                }}
              />}
            {(
              // eslint-disable-next-line camelcase
              (isLangQPValid && (isChannelsQPValid && channelsQP_upc === "SATELLITE")) ||
              // eslint-disable-next-line camelcase
              ((channelsQP_upc && isChannelsQPValid) ?
                  // eslint-disable-next-line camelcase
                  (channelsQP_upc === "SATELLITE") :
                  (isLangQPValid && (!isModalSrcValid || !isChannelsQPValid || !isPkgQPValid || !isCmprPkgQPValid))) ||
              // eslint-disable-next-line camelcase
              ((channelsQP_upc && isChannelsQPValid) ?
                  // eslint-disable-next-line camelcase
                  (channelsQP_upc === "SATELLITE") :
                  (!isModalSrcValid || !isChannelsQPValid || !isLangQPValid || !isPkgQPValid || !isCmprPkgQPValid)) ||
              packages?.length === 0
            ) &&
              <DtvButton
                analytics={satelliteChnlsPDFLink?.analytics}
                mode={satelliteChnlsPDFLink?.mode || "light"}
                tabIndex={0}
                variant={satelliteChnlsPDFLink?.variant || "uxtext"}
                {...satelliteChnlsPDFLink}
                sx={{
                  display: "block !important",
                  textAlign: "left",
                  color: "#2E70BD",
                  marginTop: {
 xs: "32px",
sm: "18px"
},
                  fontSize: "16px",
                  width: "fit-content",
                  ":focus": {
                    border: "2px solid #3885E1",
                    borderRadius: '100px'
                  }
                }}
              />}
          </>
        ) : (
          <>
            {(
              // eslint-disable-next-line camelcase
              (isLangQPValid && (isChannelsQPValid && channelsQP_upc === "INTERNET")) ||
              // eslint-disable-next-line camelcase
              ((channelsQP_upc && isChannelsQPValid) ?
                    // eslint-disable-next-line camelcase
                    channelsQP_upc === "INTERNET" :
                    (isLangQPValid && (!isModalSrcValid || !isChannelsQPValid || !isPkgQPValid || !isCmprPkgQPValid))) ||
              // eslint-disable-next-line camelcase
              ((channelsQP_upc && isChannelsQPValid) ?
                  // eslint-disable-next-line camelcase
                  channelsQP_upc === "INTERNET" :
                  (!isModalSrcValid || !isChannelsQPValid || !isLangQPValid || !isPkgQPValid || !isCmprPkgQPValid)) ||
              packages?.length === 0 ||
              // eslint-disable-next-line camelcase
              !channelsQP_upc
            ) &&
              <DtvButton
                analytics={internetSpanishChnlsPDFLink?.analytics}
                mode={internetSpanishChnlsPDFLink?.mode || "light"}
                tabIndex={0}
                variant={internetSpanishChnlsPDFLink?.variant || "uxtext"}
                {...internetSpanishChnlsPDFLink}
                sx={{
                  display: "block !important",
                  textAlign: "left",
                  marginTop: {
 xs: "32px",
sm: "26px"
},
                  color: "#2E70BD",
                  fontSize: "16px",
                  width: "fit-content",
                  ":focus": {
                    border: "2px solid #3885E1",
                    borderRadius: '100px'
                  }
                }}
              />}
            {(
              // eslint-disable-next-line camelcase
              (isLangQPValid && (isChannelsQPValid && channelsQP_upc === "SATELLITE")) ||
              // eslint-disable-next-line camelcase
              ((channelsQP_upc && isChannelsQPValid) ?
                    // eslint-disable-next-line camelcase
                    channelsQP_upc === "SATELLITE" :
                    (isLangQPValid && (!isModalSrcValid || !isChannelsQPValid || !isPkgQPValid || !isCmprPkgQPValid))) ||
              // eslint-disable-next-line camelcase
              ((channelsQP_upc && isChannelsQPValid) ?
                    // eslint-disable-next-line camelcase
                    channelsQP_upc === "SATELLITE" :
                    (!isModalSrcValid || !isChannelsQPValid || !isLangQPValid || !isPkgQPValid || !isCmprPkgQPValid)) ||
              packages?.length === 0 ||
              // eslint-disable-next-line camelcase
              !channelsQP_upc
            ) &&
              <DtvButton
                analytics={satelliteSpanishChnlsPDFLink?.analytics}
                mode={satelliteSpanishChnlsPDFLink?.mode || "light"}
                tabIndex={0}
                variant={satelliteSpanishChnlsPDFLink?.variant || "uxtext"}
                {...satelliteSpanishChnlsPDFLink}
                sx={{
                  display: "block !important",
                  textAlign: "left",
                  color: "#2E70BD",
                  marginTop: {
 xs: "32px",
sm: "18px"
},
                  fontSize: "16px",
                  width: "fit-content",
                  ":focus": {
                    border: "2px solid #3885E1",
                    borderRadius: '100px'
                  }
                }}
              />}
          </>
        )}
      </DtvBox>
    </DtvBox>
  );
};

export default PdfLinksErrorDisplay;
